// src/ts/geolocationWatcher.ts
export function initGeolocationWatcher() {
	if (!('permissions' in navigator) || !('geolocation' in navigator)) {
		console.warn('Geolocation or Permissions API not supported');
		return;
	}

	navigator.permissions.query({ name: 'geolocation' }).then((perm) => {
		console.log('[geo] initial permission:', perm.state);
		updateLocalStorage(perm.state);

		// Handle permission state changes
		perm.onchange = async () => {
			console.log('[geo] permission changed:', perm.state);
			updateLocalStorage(perm.state);

			if (perm.state === 'granted') {
				navigator.geolocation.getCurrentPosition((pos) => {
					localStorage.setItem('moebler:persistant:location', JSON.stringify(pos.coords));
					dispatchEvent(new CustomEvent('moebler:location:update', { detail: pos.coords }));
				});
			} else {
				localStorage.removeItem('moebler:persistant:location');
				dispatchEvent(new CustomEvent('moebler:location:cleared'));
			}
		};
	});
}

function updateLocalStorage(state: PermissionState) {
	localStorage.setItem('moebler:persistant:permission', state);
}
